module.exports = __webpack_public_path__ + "img/9791156330264.71606f3c.jpg";